var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-app"},[_c('the-header'),_c('router-view',{staticClass:"main-container"}),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }